<app-gc-header
  [titleString]="'guideTitle' | translate"
  [iconName]="'filePdf'"
/>
<gc-button
  [icon]="'chevronLeft'"
  [iconPosition]="'left'"
  [variant]="'plain'"
  (clicked)="goToHomePage()"
  >{{ 'backButtonText' | translate }}
</gc-button>

<div class="guide-document">
  <div class="searchbar">
    <gc-input-field
      [placeholder]="'Search'"
      [icon]="'magnifyingGlass'"
      (changed)="setSearchInputString($event)"
    />

    @if (noResultsFound()) {
      <gc-text [variant]="'paragraph'"
        >No results found for '{{ searchInputString() }}'</gc-text
      >
    }
  </div>

  @for (section of visibleGuideSections(); track section.key) {
    <div class="content">
      <gc-text [variant]="'subHeading'">{{ section.label }}</gc-text>
      <div class="grid">
        @for (guide of section.guides; track guide.path) {
          <div>
            <app-guide-document-card
              [variant]="guide.variant"
              [fileName]="guide.path"
              [title]="guide.title"
            />
          </div>
        }
      </div>
    </div>
  }
</div>
